import { useRequiredContext } from "@redotech/react-util/context";
import { RedoConciergeRpcClientContext } from "@redotech/redo-merchant-app-common/concierge-rpc-client-provider";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { ConversationInsightType } from "@redotech/redo-shopper-agent-common/trigger-definition";
import { ShopperAgentInsightsSection } from "@redotech/redo-web/concierge/analytics/shopper-agent-insights-section";
import { useRpcQuery } from "@redotech/redo-web/rpc-query/use-rpc-query";
import { memo, useMemo } from "react";

/** Sentiment/topics/handled-by breakdown for MARKETING-type shopper-agent conversations. */
export const MarketingAnalyticsSentimentTopics = memo(
  function MarketingAnalyticsSentimentTopics({
    dateFilter,
  }: {
    dateFilter: [Temporal.PlainDate, Temporal.PlainDate] | undefined;
  }) {
    const team = useRequiredContext(TeamContext);
    const shopperAgentEnabled = !!team.settings.shopperAgent?.enabled;

    const range = useMemo(() => {
      const today = Temporal.Now.plainDateISO();
      const [start, end] = dateFilter ?? [today.subtract({ days: 30 }), today];
      return {
        start: new Date(
          start.toZonedDateTime({ timeZone: "UTC" }).epochMilliseconds,
        ),
        end: new Date(
          end
            .toZonedDateTime({ timeZone: "UTC" })
            .add({ hours: 23, minutes: 59, seconds: 59 }).epochMilliseconds,
        ),
      };
    }, [dateFilter]);

    const { data, isLoading } = useRpcQuery(
      RedoConciergeRpcClientContext,
      "shopperAgentInsightsAnalytics",
      {
        start: range.start,
        end: range.end,
        conversationType: ConversationInsightType.MARKETING,
      },
      { enabled: shopperAgentEnabled },
    );

    if (!shopperAgentEnabled) {
      return null;
    }

    return <ShopperAgentInsightsSection data={data} pending={isLoading} />;
  },
);
